export const useToken = (storageKey: string) => {
  const getToken = () => localStorage.getItem(storageKey);

  const setToken = (value: string) => {
    localStorage.setItem(storageKey, value);
  };

  const clearToken = () => {
    localStorage.removeItem(storageKey);
  };

  return { getToken, setToken, clearToken };
};

export const useSimulationToken = () => useToken('simulationToken');
export const useUserReviewToken = () => useToken('userReviewToken');
